import { Component, OnInit, Optional, Inject } from '@angular/core';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import * as _ from "lodash";

@Component({
  selector: 'esc-alloc-filter',
  templateUrl: './alloc-filter.component.html',
  styleUrls: ['./alloc-filter.component.scss']
})
export class AllocFilterComponent implements OnInit {
  selectedCampaign;
  selectedWebUser;
  selectedGroup;
  campaignDistributionSelectorLabel = "LABEL_CAMPAIGN_DISTRIBUTION"
  webUserSelectorLabel = "LABEL_WEB_USER"
  groupSelectorLabel = "LABEL_GROUP"
  isWebUserMultiSelect = false;
  isDownload = false;

  constructor(
    public media: MediaObserver,
    public helper: HelperService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public dialogRef: MatDialogRef<AllocFilterComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.checkIfHasPreviousData();

    // Flag if show web user multiselect or single select dropdown
    this.isWebUserMultiSelect = _.get(this.data, 'isWebUserMultiSelect');

    // Flag if label on button will show "Apply" or "Download"
    this.isDownload = _.get(this.data, 'isDownload');
  }

  ngOnDestroy() {}

  checkIfHasPreviousData() {
    if(_.get(this.data, 'selectedCampaign')) {
      this.selectedCampaign = _.get(this.data, 'selectedCampaign');
    }
    if(_.get(this.data, 'selectedWebUser')) {
      this.selectedWebUser = _.get(this.data, 'selectedWebUser');
    }
    if(_.get(this.data, 'selectedGroup')) {
      this.selectedGroup = _.get(this.data, 'selectedGroup');
    }
  }

  campaignDistributionSelected(ev) {
    this.selectedCampaign = _.cloneDeep(ev);
    this.selectedWebUser = null;
    this.selectedGroup = null;
  }

  webUserSelected(ev) {
    this.selectedWebUser = _.cloneDeep(ev);
    this.selectedGroup = null;
  }

  groupSelected(ev) {
    this.selectedGroup = _.cloneDeep(ev);
  }

  applyFilters() {
    let webUser = _.get(this, 'selectedWebUser');
    
    // If user logged in has role of MEDREP, set their id as selected, since web user dropdown is hidden for MEDREP
    if (this.helper.isUserMedrep()) {
      webUser = { user_id: localStorage.getItem("userId") };

      // If in allocation upload module, put it in list for download request
      if (this.isWebUserMultiSelect) {
        webUser = [webUser];
      } 
    }

    let retObj = {
      selectedCampaign: _.get(this, 'selectedCampaign'),
      selectedWebUser: webUser,
      selectedGroup: _.get(this, 'selectedGroup'),
    }

    if(_.get(this.data, 'allocationLevel') == 'one' || ((_.get(this.data, 'allocationLevel') == 'two') && !this.helper.isUserAdmin())) {
      if(_.get(retObj, 'selectedCampaign') && _.get(retObj, 'selectedGroup')) {
        this.dialogRef.close(retObj);
      }
    } 
    else {
      if(_.get(retObj, 'selectedCampaign') && _.get(retObj, 'selectedWebUser') && _.get(retObj, 'selectedGroup')) {
        this.dialogRef.close(retObj);
      }
    }
  }

  disableApply() {
    return !this.selectedCampaign || !this.selectedGroup;
  }

  reset() {
    this.campaignDistributionSelected(null);
    this.webUserSelected(null);
    this.groupSelected(null);
  }
  
}
